import { auth } from '@monorepo/utils/firebase'
import { GoogleAuthProvider, signInWithPopup } from '@monorepo/utils/firebase'

export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider()
  const result = await signInWithPopup(auth(), provider)
  const user = result.user
  return {
    provider: 'google',
    user,
  }
}
